import React, {
  useEffect, useMemo, useRef, useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import styles from '../css/index.module.scss';
import MyModal from '../../../components/MyModal';
import { ARTICLES_MODAL_STATES } from '../constants';
import MyButton from '../../../components/MyButton';
import Api from '../../../Api';
import sendRequest from '../../../helpers/sendRequest';
import SearchInput from '../../../components/SearchInput';
import useInputState from '../../../helpers/hooks/useInputState';
import {
  createArticle,
  createArticleBlock, deleteArticle,
  deleteArticleBlock,
  updateArticleBlock,
} from '../../../store/actions/articles';
import getFormData from '../../../helpers/getFormData';

function ArticlesModal({
  modalState,
  setModalState,

  articleBlockToInteract,
  selectedArticleBlock,
  setSelectedArticleBlock,

  selectedArticle,
  setSelectedArticle,
}) {
  const dispatch = useDispatch();
  const fileInput = useRef(null);
  const { countries } = useSelector((store) => store.staticData);
  const { systemCountry } = useSelector((store) => store.account);

  const [name, setName, nameError, setNameError] = useInputState('');
  const [selectedFile, setSelectedFile, selectedFileError, setSelectedFileError] = useInputState(null);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const addArticleBlock = async () => {
    if (name?.length < 2) {
      return setNameError('Минимум 2 символа');
    }

    const data = await sendRequest({
      request: Api.createArticleBlock,
      payload: { name, country_id: systemCountry?._id },
      setLoading,
    });

    if (data?.status === 'ok') {
      dispatch(createArticleBlock(data.articleBlock));
      closeModal();
    } else {
      alert(data?.message);
    }
  };

  const renameArticleBlock = async () => {
    if (name?.length < 2) {
      return setNameError('Минимум 2 символа');
    }

    const data = await sendRequest({
      request: Api.renameArticleBlock,
      payload: { id: articleBlockToInteract._id, name, country_id: systemCountry?._id },
      setLoading,
    });

    if (data?.status === 'ok') {
      dispatch(updateArticleBlock(data.articleBlock));
      if (selectedArticleBlock?._id === data.articleBlock?._id) setSelectedArticleBlock(data.articleBlock);
      closeModal();
    } else {
      alert(data?.message);
    }
  };

  const deleteArticleBlockClick = async () => {
    const data = await sendRequest({
      request: Api.deleteArticleBlock,
      payload: { id: articleBlockToInteract._id, country_id: systemCountry?._id },
      setLoading,
    });

    if (data?.status === 'ok') {
      dispatch(deleteArticleBlock(data.articleBlock));
      if (selectedArticleBlock?._id === data.articleBlock?._id) setSelectedArticleBlock(null);
      closeModal();
    }
  };

  const addArticle = async () => {
    let flag = false;
    if (name?.length < 2) {
      setNameError('Минимум 2 символа');
      flag = true;
    }
    if (!selectedFile) {
      setSelectedFileError('Выберите файл');
      flag = true;
    }
    if (flag) return;

    const formData = getFormData(
      { name, article_block_id: selectedArticleBlock?._id },
      [selectedFile],
    );

    const data = await sendRequest({
      request: Api.createArticle,
      payload: { formData, country_id: systemCountry?._id },
      setLoading,
    });

    if (data?.status === 'ok') {
      dispatch(createArticle(data.article));
      closeModal();
    } else {
      alert(data?.message);
    }
  };

  const deleteArticleClick = async () => {
    const data = await sendRequest({
      request: Api.deleteArticle,
      payload: { id: selectedArticle._id, country_id: systemCountry?._id },
      setLoading,
    });

    if (data?.status === 'ok') {
      dispatch(deleteArticle(data.article));
      if (selectedArticle?._id === data.article?._id) setSelectedArticle(null);
      closeModal();
    }
  };

  const handleFile = (ev) => {
    if (ev.target.files?.length) {
      setSelectedFile(ev.target.files[0], true);
    }
  };

  const closeModal = () => {
    if (loading) {
      return;
    }

    setIsModalOpen(false);
    setTimeout(() => {
      setModalState('');
      setName('', true);
      setSelectedFile(null, true);
      setLoading(false);
    }, 400);
  };

  useEffect(() => {
    setIsModalOpen(Boolean(modalState));
    if (modalState === ARTICLES_MODAL_STATES.renameArticleBlock) {
      setName(articleBlockToInteract.name, true);
    } else if (modalState === ARTICLES_MODAL_STATES.renameSubArticleBlock) {
      setName(subArticleBlockToInteract.name, true);
    }
  }, [modalState]);

  return (
    <MyModal
      isOpen={isModalOpen}
      closeFunction={closeModal}
    >
      <div className={styles.modal}>
        {modalState === ARTICLES_MODAL_STATES.newArticleBlock ? (
          <>
            <p className={styles.title}>Новая категория</p>
            <p className={styles.info}>
              Введите название для новой категории статей.
            </p>

            <div className={styles.input}>
              <SearchInput
                withLeftIcon={false}
                value={name}
                onChange={setName}
                placeholder="Название"
                error={nameError}
              />
            </div>

            <div className={styles.buttonsRow}>
              <MyButton
                text="Отмена"
                secondary
                disabled={loading}
                onClick={closeModal}
              />
              <MyButton
                text="Добавить"
                loading={loading}
                onClick={addArticleBlock}
              />
            </div>
          </>
        ) : modalState === ARTICLES_MODAL_STATES.renameArticleBlock ? (
          <>
            <p className={styles.title}>Переименовать категорию</p>
            <p className={styles.info}>
              Введите новое название для категории статей.
            </p>

            <div className={styles.input}>
              <SearchInput
                withLeftIcon={false}
                value={name}
                onChange={setName}
                placeholder="Название"
                error={nameError}
              />
            </div>

            <div className={styles.buttonsRow}>
              <MyButton
                text="Отмена"
                secondary
                disabled={loading}
                onClick={closeModal}
              />
              <MyButton
                text="Сохранить"
                loading={loading}
                onClick={renameArticleBlock}
              />
            </div>
          </>
        ) : modalState === ARTICLES_MODAL_STATES.deleteArticleBlock ? (
          <>
            <p className={styles.title}>Удалить?</p>
            <p className={styles.info}>
              Вы уверены что хотите удалить данную категорию статей (
              {articleBlockToInteract.name}
              )?
            </p>
            <p className={styles.info}>
              Категория не будет полностью удалена из базы, а будет скрыта.
            </p>

            <div className={styles.buttonsRow}>
              <MyButton
                text="Отмена"
                secondary
                disabled={loading}
                onClick={closeModal}
              />
              <MyButton
                text="Удалить"
                loading={loading}
                onClick={deleteArticleBlockClick}
              />
            </div>
          </>
        ) : modalState === ARTICLES_MODAL_STATES.newArticle ? (
          <>
            <p className={styles.title}>Новая статья</p>
            <p className={styles.info}>
              Введите название для новой статьи и выберите шапку.
            </p>

            <div className={styles.input}>
              <SearchInput
                withLeftIcon={false}
                value={name}
                onChange={setName}
                placeholder="Название"
                error={nameError}
              />
            </div>

            <div className={classNames(styles.input, styles.inputFile)}>
              <MyButton
                text={selectedFile ? 'Поменять шапку' : 'Выбрать шапку'}
                onClick={() => fileInput.current?.click()}
                className={styles.inputButton}
              />
              {selectedFile && (
                <img
                  className={styles.inputPhoto}
                  src={URL.createObjectURL(selectedFile)}
                  alt="file"
                />
              )}
              {selectedFileError && <p className={styles.inputFileError}>{selectedFileError}</p>}
              <input
                ref={fileInput}
                type="file"
                hidden
                onChange={handleFile}
                accept="image/png, image/jpeg"
              />
            </div>

            <div className={styles.buttonsRow}>
              <MyButton
                text="Отмена"
                secondary
                disabled={loading}
                onClick={closeModal}
              />
              <MyButton
                text="Добавить"
                loading={loading}
                onClick={addArticle}
              />
            </div>
          </>
        ) : modalState === ARTICLES_MODAL_STATES.deleteArticle ? (
          <>
            <p className={styles.title}>Удалить?</p>
            <p className={styles.info}>
              Вы уверены что хотите удалить данную статью (
              {selectedArticle?.name}
              )?
            </p>
            <p className={styles.info}>
              Статья не будет полностью удалена из базы, а будет скрыта.
            </p>

            <div className={styles.buttonsRow}>
              <MyButton
                text="Отмена"
                secondary
                disabled={loading}
                onClick={closeModal}
              />
              <MyButton
                text="Удалить"
                loading={loading}
                onClick={deleteArticleClick}
              />
            </div>
          </>
        ) : null }
      </div>
    </MyModal>
  );
}

export default ArticlesModal;
